import PropTypes from 'prop-types';

export const coordPropType = PropTypes.shape({
  lat: PropTypes.number,
  lng: PropTypes.number,
});
